import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=536a47af&scoped=true&"
import script from "./account-detail.vue?vue&type=script&lang=js&"
export * from "./account-detail.vue?vue&type=script&lang=js&"
import style0 from "./account-detail.vue?vue&type=style&index=0&id=536a47af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a47af",
  null
  
)

export default component.exports